export const state = () => ({
  lastList: [],
  isLoadLastList: false,
})

export const mutations = {
  changeLoadLastList (state, val) {
    state.isLoadLastList = val;
  }
}
export const actions = {
  checkLastOrders: async function (params) {
    if (params.state?.isLoadLastList) {
      return
    }

    const isUserAuth = Boolean(params?.rootState?.user?.user?.id);
    if (!isUserAuth) {
      return
    }

    params.commit('changeLoadLastList', true);

    const commerceOrders = await this.$api.agent.transport.get('/users/commerce-orders?expand=items').then((res) => {
      return res.data || []
    }).catch(() => {
      return []
    });
    if (commerceOrders.length <= 0) {
      return
    }

    const certificateProductId = String(process.env.certificatProductId || process.env.CERTIFICAT_PRODUCT_ID);

    let ignoredSavedOrder = [];
    commerceOrders.map((order) => {
      const orderItems = order?.items || [];
      const paymentStatus = String(order?.payment_status || '0');
      const isOrderCertificate = Boolean(orderItems.find((orderItem) => Boolean(certificateProductId === String(orderItem?.product_id))));
      if (isOrderCertificate && paymentStatus === '1') {
        this.$yandexMetrika.reachGoal('pay_sert');
      }
      if (isOrderCertificate && paymentStatus !== '1') {
        ignoredSavedOrder.push(order.id)
      }
    });

    const orderIds = commerceOrders
      .filter((orderItem) => !Boolean(ignoredSavedOrder.includes(orderItem.id)))
      .map((t) => t.id);

    if (orderIds.length <= 0) {
      params.commit('changeLoadLastList', false);
      return
    }
    const body = {
      order_ids: orderIds
    };
    const res = await this.$api.agent.transport.post('/users/commerce-orders-save', body).then(() => {
      return true
    }).catch(() => {
      return false
    });

    params.commit('changeLoadLastList', false);
  }
}
